import { Button, ButtonGroup, Icon, Skeleton } from '@chakra-ui/react';
import { FiChevronLeft, FiHome, FiLogIn } from 'react-icons/fi';
import { LOGIN_ENABLED } from '../config';
import { LuNotepadText } from 'react-icons/lu';
import { LuPanelTop } from 'react-icons/lu';
import type { NavConfig } from './navigationData';
import { NavLink } from 'react-router-dom';
import { UserMenu } from './UserMenu';

type CornerButtonsProps = {
    user: any;
    userLoading: boolean;
    config: NavConfig;
    isAdmin: boolean;
    locationPathname: string;
    navigate: (path: string) => void;
    handleLogout: () => Promise<void>;
};

export function CornerButtons({
    user,
    userLoading,
    config,
    isAdmin,
    locationPathname,
    navigate,
    handleLogout,
}: CornerButtonsProps) {
    if (userLoading) {
        return (
            <ButtonGroup size="sm" flexShrink={0} gap={1} alignItems="center">
                <Skeleton height="36px" width="96px" borderRadius="md" />
                <Skeleton height="36px" width="36px" borderRadius="md" />
            </ButtonGroup>
        );
    }

    if (config.showBackButton) {
        return (
            <Button size="sm" variant="ghost" fontWeight="semibold" colorScheme="orange" onClick={() => navigate('/?noRedirectToPanel')}>
                <Icon as={FiChevronLeft} boxSize={4} mr={2} />
                Powrót
            </Button>
        );
    }

    if (!user) {
        return (
            <ButtonGroup gap={0}>
                <Button asChild size="sm" fontWeight="semibold" colorPalette="orange" variant="ghost" mr={2}>
                    <NavLink to="/zapisy">
                        <Icon as={LuNotepadText} boxSize={4} />
                        Zapisy
                    </NavLink>
                </Button>
                {LOGIN_ENABLED && (
                    <Button asChild size="sm" variant="outline" flexShrink={0} fontWeight="semibold">
                        <NavLink to="/login">
                            <Icon as={FiLogIn} boxSize={4} />
                            Zaloguj się
                        </NavLink>
                    </Button>
                )}
            </ButtonGroup>
        );
    }

    return (
        <ButtonGroup size="sm" variant="solid" flexShrink={0} gap={1}>
            <Button asChild size="sm" fontWeight="semibold" colorPalette="orange" variant="ghost">
                <NavLink to="/zapisy">
                    <Icon as={LuNotepadText} boxSize={4} />
                    Zapisy
                </NavLink>
            </Button>
            {locationPathname === '/' && (
                <Button asChild size="sm" variant="solid" colorPalette="orange">
                    <NavLink to={isAdmin ? '/admin' : '/panel'}>
                        <Icon as={LuPanelTop} boxSize={4} />
                        {isAdmin ? 'Admin panel' : 'Panel klienta'}
                    </NavLink>
                </Button>
            )}
            {(locationPathname.startsWith('/admin') || locationPathname.startsWith('/panel')) && (
                <Button asChild size="sm" variant="ghost" colorPalette="gray">
                    <NavLink to={'/?noRedirectToPanel'}>
                        <Icon as={FiHome} boxSize={4} />
                    </NavLink>
                </Button>
            )}
            <UserMenu user={user} handleLogout={handleLogout} />
        </ButtonGroup>
    );
}
